import React, { useEffect, useMemo, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import * as approvalV2Api from '../../lib/api/approvalV2';

const ApprovalMngPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [canManageAuths, setCanManageAuths] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchManagePermission = async () => {
      try {
        const res = await approvalV2Api.getApprovalV2AuthManagePermission();
        if (mounted) {
          setCanManageAuths(Boolean(res.data?.canManage));
        }
      } catch (e) {
        if (mounted) {
          setCanManageAuths(false);
        }
      }
    };

    fetchManagePermission();
    return () => {
      mounted = false;
    };
  }, []);

  const currentTab = useMemo(() => {
    if (location.pathname.startsWith('/approvalmng/submitted')) {
      return 'submitted';
    }
    if (location.pathname.startsWith('/approvalmng/monitoring')) {
      return 'monitoring';
    }
    if (location.pathname.startsWith('/approvalmng/lines')) {
      return 'lines';
    }
    if (location.pathname.startsWith('/approvalmng/delegations')) {
      return 'delegations';
    }
    if (location.pathname.startsWith('/approvalmng/auths')) {
      return 'auths';
    }
    return 'inbox';
  }, [location.pathname]);

  const handleChange = (_event, value) => {
    navigate(`/approvalmng/${value}`);
  };

  const tabValue = currentTab === 'auths' && !canManageAuths ? false : currentTab;

  return (
    <Box sx={{ p: 3 }}>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab value="submitted" label="내 기안함" />
        <Tab value="inbox" label="결재함" />
        <Tab value="lines" label="결재선 템플릿" />
        <Tab value="delegations" label="대결 관리" />
        {canManageAuths && <Tab value="auths" label="전결 권한" />}
        <Tab value="monitoring" label="결재 모니터링" />
      </Tabs>
      <Outlet />
    </Box>
  );
};

export default ApprovalMngPage;
